import type React from "react";
import styles from "./KnowledgeStatusBadge.module.scss";

/**
 * 【機能概要】: ナレッジの有効/無効状態を表示するスライダーコンポーネント
 * 【実装方針】: トグルスイッチで状態切り替えを可能にする
 * 【要件対応】: 要件定義書2.3（一覧への状態表示）に基づく
 * 🟡 信頼性レベル: 中（ユーザーが状態を把握するために重要）
 *
 * @param {boolean} isActive - ナレッジの有効/無効状態
 * @param {() => void} onToggle - 状態切り替え時のコールバック
 * @param {boolean} disabled - トグル無効化フラグ（ローディング中など）
 */
interface KnowledgeStatusBadgeProps {
  isActive: boolean;
  onToggle?: (() => void) | undefined;
  disabled?: boolean | undefined;
}

const KnowledgeStatusBadge: React.FC<KnowledgeStatusBadgeProps> = ({
  isActive,
  onToggle,
  disabled = false,
}) => {
  // 【イベントハンドラ】: スライダー変更時の処理
  // 【実装方針】: イベントの伝播を止めて、親の行クリックイベントを防ぐ
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation(); // 行クリックイベントを防ぐ
    if (!disabled && onToggle) {
      onToggle();
    }
  };

  return (
    <label className={styles["switch"]} onClick={(e) => e.stopPropagation()}>
      <input
        type="checkbox"
        checked={isActive}
        onChange={handleChange}
        disabled={disabled || !onToggle}
        aria-label={
          onToggle
            ? isActive
              ? "有効（クリックで無効化）"
              : "無効（クリックで有効化）"
            : "権限がありません"
        }
      />
      <span className={styles["slider"]}></span>
    </label>
  );
};

export default KnowledgeStatusBadge;
